import FormValidator from './FormValidator';
import { useState, useEffect, useCallback } from "react";
import _, { cloneDeep, set } from 'lodash';

export default function useFieldItem(FIELDS: any, initialValues: any, options: any) {

    const { preValidation, postValidation, onValueChange } = options;
    const [values, setValues] = useState(initialValues);
    const [fields, setFields] = useState({});

    useEffect(() => {
        if (!_.isEmpty(initialValues))
            setValues(initialValues);
    }, [initialValues])

    const changeHandler = (name: any, value: any, obj: any) => {
        const { isTouched } = obj || {
            isTouched: false
        };
        if (isTouched) {
            return false;
        }

        const fieldValues: any = { ...fields };

        if (FIELDS[name] && fieldValues && Object.keys(fieldValues).length > 0) {
            const validate = FormValidator(name, value, FIELDS[name], preValidation, postValidation);
            if (validate) {
                fieldValues[name] = validate;
            } else {
                fieldValues[name] = {
                    hasError: false,
                    errorMsg: ''
                };
            }
        setFields(fieldValues);
        }

        const [newValues = null] = onValueChange ? onValueChange(name, value, values, fieldValues) || [] : [];

        setValues((values: any) => {
            if (newValues != null) return newValues;

            return ({
                ...values,
                [name]: value
            })

        })

        let temp: any = cloneDeep(fields);
        if (isTouched && temp[name] && temp[name].hasError) {
            setFields(temp);
            return false;
        }
    }

    const updateError = (name, data) => {
        console.log(name, data, fields);
        setFields(prevFields => {
            const fieldValues: any = { ...prevFields };
            fieldValues[name] = data;
            console.log(name, data, fieldValues);
            return fieldValues;
        });
    }

    const updateAllError = (data) => {
        console.log(data);
        if (!data) return;
        setFields(prevFields => {
            const fieldValues: any = { ...prevFields };
            data.forEach((key: any) => {
                fieldValues[key.name] = key.data;
            });
            return fieldValues;
        });
    }

    const updateAllRules = (data) => {
        console.log(data);
        if (!data) return;
        setFields(prevFields => {
            const fieldValues: any = { ...prevFields };
            data.forEach((key: any) => {
                fieldValues[key.name] = key.data;
            });
            return fieldValues;
        });
    }

    const removeErrors = (index = null) => {
        setFields(prevFields => {
            const fieldValues: any = { ...prevFields };

            if (index === null) {
                // Remove all errors
                Object.keys(fieldValues).forEach(key => {
                    fieldValues[key] = {
                        ...fieldValues[key],
                        hasError: false,
                        errorMsg: ""
                    };
                });
            } else {
                // Remove error for specific index
                fieldValues[index] = {
                    ...fieldValues[index],
                    hasError: false,
                    errorMsg: ""
                };
            }

            return fieldValues;
        });
    };


    const validator = (keys: any, removedKeys = []) => {
        let hasError = false;
        setFields(prevFields => {
            const fieldValues: any = { ...prevFields };

            // Clear removed keys
            if (removedKeys.length > 0) {
                removedKeys.forEach(key => {
                    fieldValues[key] = {
                        hasError: false,
                        errorMsg: ''
                    };
                });
            }

            // Validate keys
            keys.forEach((key: any) => {
                const validate = FormValidator(key, values[key], FIELDS[key], preValidation, postValidation);
                if (validate) {
                    fieldValues[key] = validate;
                } else {
                    fieldValues[key] = {
                        hasError: false,
                        errorMsg: ''
                    };
                }
            });

            // Check for errors in validated keys
            keys.forEach((key: any) => {
                if (fieldValues[key] && fieldValues[key].hasError) {
                    hasError = true;
                }
            });

            return fieldValues;
        });

        return hasError;
    }

    const valuesReset = (resetArray: []) => {
        setValues(initialValues);
        setFields({});
    };

    const updateValues = (newValue: any) => {
        if (!newValue) return;

        const fieldValues: any = {};
        Object.keys(newValue).forEach(val => {
            if (FIELDS[val]) {
                const validate = FormValidator(val, newValue[val], FIELDS[val], preValidation, postValidation);
                if (validate) {
                    fieldValues[val] = validate;
                } else {
                    fieldValues[val] = {
                        hasError: false,
                        errorMsg: ''
                    };
                }
            }
        });

        setValues(prevValues => ({
            ...prevValues,
            ...newValue
        }));
        setFields(prevFields => ({
            ...prevFields,
            ...fieldValues
        }));
    }

    const resetValues = (newValue: any) => {
        if (!newValue) return;

        const fieldValues: any = {};
        Object.keys(newValue).forEach(val => {
            if (FIELDS[val]) {
                fieldValues[val] = {
                    hasError: false,
                    errorMsg: ''
                };
            }
        });

        setValues(prevValues => ({
            ...prevValues,
            ...newValue
        }));
        setFields(prevFields => ({
            ...prevFields,
            ...fieldValues
        }));
    }

    const handleChange = useCallback(
        changeHandler,
        [FIELDS, onValueChange, preValidation, postValidation],
    );

    const validateValues = useCallback(
        validator,
        [values, FIELDS, preValidation, postValidation],
    );

    const reset = useCallback(
        valuesReset,
        [initialValues],
    );

    const updateValue = useCallback(
        updateValues,
        [FIELDS, preValidation, postValidation],
    )

    const resetValue = useCallback(
        resetValues,
        [FIELDS, preValidation, postValidation],
    )

    return [values, fields, handleChange, { validateValues, reset, updateValue, resetValue, updateError, removeErrors, updateAllError, updateAllRules }]
}